import { Form } from 'antd';
import styled, { css } from 'styled-components';
import { DefaultRangePicker, styleVariables } from '@lib/common';
import TextArea from 'antd/lib/input/TextArea';
import { disabledDate, disabledTime } from '../utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var verticalStyle = css([".ant-row{display:flex;flex-flow:row;align-items:center;.ant-col{max-width:50%;&:last-child{margin-left:10px;}}}.ant-form-item-label{padding:0px;text-align:center;}.ant-switch-checked{background-color:", ";}"], styleVariables.colors.blue4);
var StyledFormInput = styled(Form).withConfig({
  displayName: "publish-score-formcomponent__StyledFormInput",
  componentId: "sc-1gq3soz-0"
})([".ant-row{margin-bottom:10px;}.ant-form-item-label{font-weight:500;}.ant-form-item-control-input{min-height:auto;}"]);
export var StyledRequiredMark = styled.span.withConfig({
  displayName: "publish-score-formcomponent__StyledRequiredMark",
  componentId: "sc-1gq3soz-1"
})(["color:", ";margin-left:4px;"], styleVariables.colors.red4);
export var InlineOption = styled(Form.Item).withConfig({
  displayName: "publish-score-formcomponent__InlineOption",
  componentId: "sc-1gq3soz-2"
})(["", " ", " ", ""], verticalStyle, function (props) {
  return props.isDropDown && "\n        margin-bottom: 0px;\n        margin-top: 24px;\n      ";
}, function (props) {
  return props.isSelectOnly && "\n        margin-bottom: 24px;\n        margin-top: 24px;\n      ";
});
export var PublishScoreForm = function PublishScoreForm(props) {
  var form = props.form,
      label = props.label,
      errorLabel = props.errorLabel,
      onFormValuesChange = props.onFormValuesChange,
      onContinue = props.onContinue;

  var renderLinkExpiredAtInput = function renderLinkExpiredAtInput() {
    return /*#__PURE__*/_jsx(Form.Item, {
      label: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("span", {
          children: label.linkExpiredAt
        }), /*#__PURE__*/_jsx(StyledRequiredMark, {
          children: "*"
        })]
      }),
      name: "linkExpiredAt",
      rules: [{
        required: true,
        message: errorLabel.notEmptyLinkExpiredAt
      }],
      children: /*#__PURE__*/_jsx(DefaultRangePicker, {
        disabledDate: disabledDate,
        disabledTime: disabledTime,
        showTime: {
          format: 'HH:mm'
        },
        format: "DD/MM/YYYY - HH:mm",
        placeholder: [label.expireLinkStartTime, label.expireLinkEndTime]
      })
    });
  };

  var renderNote = function renderNote() {
    return /*#__PURE__*/_jsx(Form.Item, {
      label: label.note,
      name: "note",
      children: /*#__PURE__*/_jsx(TextArea, {
        size: "middle",
        placeholder: label.noteInputPlaceHolder
      })
    });
  };

  return /*#__PURE__*/_jsxs(StyledFormInput, {
    form: form,
    layout: "vertical",
    onValuesChange: onFormValuesChange,
    requiredMark: false,
    children: [renderLinkExpiredAtInput(), renderNote()]
  });
};